import React, { useEffect, useRef } from "react"
import { format, isToday } from "date-fns"
import ReactMarkdown from "react-markdown"

import { Message } from "@/types/chatbot"
import { ScrollArea } from "@/components/ui/scroll-area"

interface ChatMessagesProps {
  messages: Message[]
}

const formatMessageDate = (date: Date) => {
  if (isToday(date)) {
    return format(date, "h:mm a")
  }
  return format(date, "MMM d, yyyy h:mm a")
}

export const ChatMessages: React.FC<ChatMessagesProps> = ({ messages }) => {
  const scrollAreaRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (scrollAreaRef.current) {
      const scrollContainer = scrollAreaRef.current.querySelector(
        "[data-radix-scroll-area-viewport]",
      )
      if (scrollContainer) {
        scrollContainer.scrollTop = scrollContainer.scrollHeight
      }
    }
  }, [messages])

  return (
    <ScrollArea ref={scrollAreaRef} className="h-full flex-1 p-4">
      <div id="chat-messages" className="space-y-4">
        {messages.map((message) => (
          <div
            key={message.id}
            className={`flex flex-col ${
              message.sender === "user" ? "items-end" : "items-start"
            }`}
          >
            <ReactMarkdown
              className={`max-w-sm overflow-x-auto whitespace-pre-wrap rounded-lg px-4 py-2 ${
                message.sender === "user"
                  ? "bg-primary text-primary-foreground"
                  : "bg-muted text-muted-foreground"
              }`}
            >
              {message.content}
            </ReactMarkdown>
            <span className="mt-1 text-xs text-muted-foreground">
              {formatMessageDate(new Date(message.created_at))}
            </span>
          </div>
        ))}
      </div>
    </ScrollArea>
  )
}
